import { usePutHttp } from "../../../../hooks/http/http.hook";
import type { IAssetMinimal } from "../../../../types/models/asset.models.types";
import type { SocialPostType } from "../../../../types/models/campaign.models.types";
import type {
  SocialCreatorType,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import type { MilestoneRewardType } from "../../../../z/brand/campaign-form.brand.z";

export interface IAsset extends IAssetMinimal {
  note: string;
}

interface IBody {
  name?: string;
  coverImage?: string | null;
  socialPlatform?: SocialPlatforms | null;
  socialPostType?: SocialPostType | null;
  socialCreatorType?: SocialCreatorType | null;
  aboutCampaign?: string | null;
  hashtags?: string | null;
  mentions?: string | null;
  do?: string | null;
  dont?: string | null;
  startDate?: string;
  endDate?: string | number;
  budget?: number | null;
  milestoneRewardType?: MilestoneRewardType | null
  minimumFollowers?: number | null;
  aboutBrand?: string | null;
  milestones?:
    | {
        count: number;
        payout: number | null;
        product: {
          image: string;
          name: string;
          description: string;
        } | null;
      }[]
    | null;
  links?:
    | {
        title: string;
        url: string;
      }[]
    | null;
  assets?: Array<string> | null;
  cpv?: {
    costPerView: number;
    maxPayout: number;
  } | null;
}

interface IResponse {
  campaign: IBody;
}

export function useUpdateCampaignHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/brand/campaigns/:campaignId",
  });
}
